module.exports = __webpack_public_path__ + "static/media/fenxsWrap.8f53ea86.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fenxsWrap.png
// module id = 1757
// module chunks = 0 1